import axios from 'axios';

const app = axios.create({
    baseURL : 'https://tweetly-a4a14-default-rtdb.firebaseio.com/'
});

export default app;